import { useFetchSessionByIdQuery } from '../../../services/sessions.api';

export const useSessionPolling = (sessionId: string | null, poll = false) => {
  const { data: sessionData, error: sessionError } = useFetchSessionByIdQuery(sessionId!, {
    skip: !sessionId,
    pollingInterval: poll ? 5000 : 0,
  });

  return { sessionData, sessionError };
};
